import { render, staticRenderFns } from "./NewRule.vue?vue&type=template&id=373512d4&scoped=true"
import script from "./NewRule.vue?vue&type=script&lang=js"
export * from "./NewRule.vue?vue&type=script&lang=js"
import style0 from "./NewRule.vue?vue&type=style&index=0&id=373512d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373512d4",
  null
  
)

export default component.exports